import { ApiResponse } from '@/modules/auth/interfaces/apiResponse';
import { AppResponse } from '@/modules/core/interfaces/appResponse';
import AuthorizedApiClient from '@/modules/auth/models/authorizedApiClient';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { DataSource } from '../interfaces/DataSource';
import { DataSourceResponse } from '../models/DataSourceResponse';
export class BrokerApi implements DataSource {
  public async fetch(endpoint: string): Promise<DataSourceResponse> {
    const response: AxiosResponse<ApiResponse<DataSourceResponse>> =
      await AuthorizedApiClient.get(endpoint);
    const data = response.data.data;
    return data;
  }
  public async getBroker(actingBrokerId?: number | null) {
    let config: AxiosRequestConfig = {};
    if (actingBrokerId) {
      config = {
        headers: {
          'X-Acting-Broker-Id': actingBrokerId,
        },
      };
    }
    const response: AxiosResponse<AppResponse<any>> =
      await AuthorizedApiClient.get('/broker', config);

    if (response.status === 200) {
      const apiResult: AppResponse<any> = response.data;

      if (apiResult.success) {
        return apiResult.data;
      }

      return null;
    }

    return null;
  }

  public async getByCompany(actingBrokerId?: number | null) {
    let config: AxiosRequestConfig = {};

    if (actingBrokerId) {
      config = {
        headers: {
          'X-Acting-Broker-Id': actingBrokerId,
        },
      };
    }

    const response: AxiosResponse<AppResponse<any>> =
      await AuthorizedApiClient.get('/broker/get-by-company', config);

    if (response.status === 200) {
      const apiResult: AppResponse<any> = response.data;

      if (apiResult.success) {
        return apiResult.data;
      }

      return null;
    }

    return null;
  }

  public async updateBroker(data: { embeddedFormConfig?: any }, actingBrokerId?: number | null) {
    let config: AxiosRequestConfig = {};
    if (actingBrokerId) {
      config = {
        headers: {
          'X-Acting-Broker-Id': actingBrokerId,
        },
      };
    }
    const response: AxiosResponse<AppResponse<any>> =
      await AuthorizedApiClient.post('/broker/update', data, config);

    if (response.status === 200) {
      const apiResult: AppResponse<any> = response.data;

      if (apiResult.success) {
        return apiResult.data;
      }

      return null;
    }

    return null;
  }

  public async reinviteBroker(brokerId: number): Promise<boolean> {
    const response: AxiosResponse<AppResponse<any>> =
      await AuthorizedApiClient.post(`/broker/reinvite/${brokerId}`);
    return response.status === 200 && response.data?.success === true;
  }
}
